<iframe #frame title="Acompanhamento Produtos" src="https://app.powerbi.com/view?r=eyJrIjoiZTcwMjFhYjctNDE5ZC00ZmFjLWFhNjAtMzQzNzRlZDZkZWVjIiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
